<crypto-detail [fullLayout]="fullLayout"></crypto-detail>
